// src/components/shared/ActivePositionsTable.jsx
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DashboardTradeModal from './DashboardTradeModal'; // Используем новое модальное окно
import { HiEye } from 'react-icons/hi';

const ActivePositionsTable = ({ positions = [], loading }) => {
  const { t } = useTranslation();
  const [selectedPos, setSelectedPos] = useState(null);
  const counts = positions.reduce(
    (acc, pos) => {
      const status = pos?.exchangeData?.status || 'UNKNOWN';
      if (status === 'OK') acc.ok += 1;
      else acc.issues += 1;
      return acc;
    },
    { ok: 0, issues: 0 }
  );

  const formatDate = (ms) => {
    if (!ms) return '—';
    return new Date(ms).toLocaleString('ru-RU', {
      day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <div className="bg-slate-800 rounded-2xl shadow-lg border border-slate-700/50 overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-700/50 flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="text-[11px] text-slate-500 uppercase tracking-widest">
            {t('dashboard.open_positions')}
          </div>
          <div className="text-sm text-slate-300">
            {t('dashboard.open_positions_hint')}
          </div>
        </div>
        <div className="flex items-center gap-2 text-xs">
          {loading ? (
            <>
              <div className="h-6 w-16 rounded-full bg-slate-700/70 animate-pulse" />
              <div className="h-6 w-16 rounded-full bg-slate-700/70 animate-pulse" />
            </>
          ) : (
            <>
              <span className="px-3 py-1 rounded-full bg-emerald-500/10 text-emerald-300 border border-emerald-500/20 font-semibold">
                {t('dashboard.open_positions_active')}: {counts.ok}
              </span>
              <span className="px-3 py-1 rounded-full bg-rose-500/10 text-rose-300 border border-rose-500/20 font-semibold">
                {t('dashboard.open_positions_issues')}: {counts.issues}
              </span>
            </>
          )}
        </div>
      </div>

      {loading ? (
        <div className="p-8 bg-slate-800/70 animate-pulse h-40"></div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-300">
            <thead className="text-xs text-gray-400 uppercase bg-slate-900/50">
              <tr>
                <th className="px-6 py-4">{t('hub.params.pair')}</th>
                <th className="px-6 py-4">Exchange</th>
                <th className="px-6 py-4">Entry Time</th>
                <th className="px-6 py-4 text-right">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-700/50">
              {positions && positions.length > 0 ? (
                positions.map((pos, idx) => {
                  const exData = pos.exchangeData || {};
                  const status = exData.status || 'UNKNOWN';
                  const isOk = status === 'OK';

                  return (
                    <tr 
                      key={pos.publicStrategyId || idx} 
                      onClick={() => isOk && setSelectedPos(pos)}
                      className={`transition-colors group ${isOk ? 'cursor-pointer hover:bg-slate-700/50' : 'hover:bg-slate-700/20'}`}
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center">
                          <div className="font-bold text-white">{pos.symbolA} / {pos.symbolB}</div>
                          {isOk && (
                            <HiEye className="ml-2 text-blue-400 w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="bg-slate-700 px-2 py-1 rounded text-[11px] font-medium">{pos.exchange}</span>
                      </td>
                      <td className="px-6 py-4 text-gray-400">
                        {formatDate(pos.entryTimeMs || pos.openedAtMs)}
                      </td>
                      <td className="px-6 py-4 text-right">
                        <span className={`px-2 py-1 rounded text-[10px] font-bold border ${
                          isOk 
                            ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' 
                            : 'bg-rose-500/10 text-rose-400 border-rose-500/20'
                        }`}>
                          {status}
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className="px-6 py-10 text-center text-gray-500 italic">
                    {t('trades.empty')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Новое модальное окно для дашборда */}
      {selectedPos && (
        <DashboardTradeModal 
          trade={selectedPos} 
          onClose={() => setSelectedPos(null)} 
        />
      )}
    </div>
  );
};

export default ActivePositionsTable;
